import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { EcommerceSectionNamespace } from '../../model';

/**
 * Ecommerce event for going back to shopping
 * this event should be called when customer leave the checkout process from first cart page
 */
export const trackCheckoutButton = (
  name: EcommerceSectionNamespace.EEcommerceName,
  type: EcommerceSectionNamespace.EEcommerceType,
  interaction: EcommerceSectionNamespace.EEcommerceInteraction,
  timing: number,
) =>
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.ELEMENT_CLICK,
      element: {
        name,
        type,
        interaction,
        timing,
      },
      _clear: true,
    }),
  );
